/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Custom metadata entries to be associated with the declared asset
 */
export type PublicCustomMetadataEntryReferenceDto = {
    /**
     * Name of the referenced custom metadata
     */
    customMetadataName: string;
    type: PublicCustomMetadataEntryReferenceDto.type;
};

export namespace PublicCustomMetadataEntryReferenceDto {

    export enum type {
        LABEL = 'LABEL',
        STRING = 'STRING',
        USER = 'USER',
        TEAM = 'TEAM',
    }


}
